import clsx from "clsx"

import { Text } from "../Text"
import styles from "./HeaderTabLink.module.css"

interface Props {
  text: string
  selected: boolean
  disabled?: boolean
  renderLink?: (children: JSX.Element) => JSX.Element
  onClick?: () => void
}

export function HeaderTabLink(props: Props) {
  const { text, selected, disabled = false, renderLink, onClick } = props

  const Content = (
    <Text
      component="span"
      variant="emphasized"
      noSelect
      color={selected ? "grey12" : "grey11"}
    >
      {text}
    </Text>
  )

  return (
    <div
      className={clsx(
        styles.root,
        disabled && styles.disabled,
        selected && styles.selected,
      )}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") onClick?.()
      }}
    >
      {renderLink?.(Content) ?? Content}
    </div>
  )
}
